import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  Companion_getInstance1toq7c46z6qs1 as Companion_getInstance,
  get_entries3onyqwuzh1iwq as get_entries,
  MemberRole_Employee_getInstance37kv78awnpbvk as MemberRole_Employee_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import {
  get_inactiveStates2yk2ks5kh401v as get_inactiveStates,
  get_employeeVisibleStates1eu9d2kkcbve5 as get_employeeVisibleStates,
} from '../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import {
  toSet2orjxp16sotqu as toSet,
  plus310ted5e4i90h as plus,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { minus165a8u1e0x1lu as minus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Projecto73xqbcrzskm as Project,
  Clientuccelyr89ch8 as Client,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_contractor2weo1umt9id6t as get_contractor,
  get_isArchived1blzbvus67h1w as get_isArchived,
  get_state23zbf4that7g as get_state,
  get_nameo9a32lyl7xbh as get_name,
} from '../../../../../../crowpay-shared/com/crowpay/ProjectFields.mjs';
import { get_notNullContractorsjk9enub7uol as get_notNullContractor } from '../../../selectedContractor.mjs';
import {
  eq1298m2cje971u as eq,
  xDataClassPathInsideSet1u5agsol0s6ul as xDataClassPathInsideSet,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import {
  or1ww9501dfiqpb as or,
  andvtrcuje7baox as and,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { get__id2siepuxebop4k as get__id } from '../../../../../../crowpay-shared/com/crowpay/ClientFields.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance } from '../common/ProjectView.mjs';
import { projectList120z2nvqx0g4u as projectList } from '../../components/project/projectList.mjs';
import {
  get_requiredMembershipRole2ywu1e77bwer8 as get_requiredMembershipRole,
  get_awaitingApprovalMessagemcfmnhjri98l as get_awaitingApprovalMessage,
  renderFinishRegistrationbdw1wx3e9bul as renderFinishRegistration,
  renderAwaitingApprovalsh6ugtdyt2je as renderAwaitingApproval,
  render2bonfr4ls49sc as render,
  ContractorPage2yk275fy06uv3 as ContractorPage,
} from './IsContractorScreen.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ContractorProjectsClass;
function ContractorProjects() {
  if (ContractorProjectsClass === VOID) {
    class $ {
      constructor() {
        this.hji_1 = new (Constant())(_Constant___init__impl__v45mub('Projects'));
        this.iji_1 = get_inactiveStates(Companion_getInstance());
        this.jji_1 = minus(toSet(get_entries()), this.iji_1);
        this.kji_1 = Signal().fak(false);
        var tmp = this;
        tmp.lji_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var session = $this$remember.baj(get_session());
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
          var tmp$ret$0 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$0);
          var tmp_0 = and(eq(get_contractor(it), $this$remember.baj(get_notNullContractor())), or(eq(get_isArchived(it), true), xDataClassPathInsideSet(get_state(it), this.iji_1)));
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
          var tmp$ret$5 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$5);
          this_0.o4a(get_state(it_0));
          this_0.m4a(get_name(it_0));
          var tmp$ret$10 = this_0.o1r();
          return session.pfv_1.feo(new (Query())(tmp_0, tmp$ret$10));
        });
        var tmp_0 = this;
        tmp_0.mji_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var session = $this$remember.baj(get_session());
          var tmp0_safe_receiver = $this$remember.baj(session.pfw_1).m88_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.j8c_1;
          var role = tmp1_elvis_lhs == null ? MemberRole_Employee_getInstance() : tmp1_elvis_lhs;
          var statuses = !role.equals(MemberRole_Employee_getInstance()) ? this.jji_1 : get_employeeVisibleStates(Companion_getInstance());
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
          var tmp$ret$11 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$11);
          var tmp_0 = and(and(eq(get_contractor(it), $this$remember.baj(get_notNullContractor())), eq(get_isArchived(it), false)), xDataClassPathInsideSet(get_state(it), statuses));
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
          var tmp$ret$16 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$16);
          this_0.o4a(get_state(it_0));
          this_0.m4a(get_name(it_0));
          var tmp$ret$21 = this_0.o1r();
          return session.pfv_1.feo(new (Query())(tmp_0, tmp$ret$21));
        });
        var tmp_1 = this;
        tmp_1.nji_1 = remember(VOID, VOID, VOID, ($this$remember) => plus($this$remember.baj($this$remember.baj(this.mji_1)), $this$remember.baj(this.kji_1) ? $this$remember.baj($this$remember.baj(this.lji_1)) : emptyList()));
        var tmp_2 = this;
        tmp_2.oji_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.mapNotNull' call
          var tmp0 = $this$remember.baj(this.nji_1);
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var destination = ArrayList().w();
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var tmp0_safe_receiver = element.c7b_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              destination.v(tmp0_safe_receiver);
            }
          }
          var ids = toSet(destination);
          var tmp = $this$remember.baj(get_session()).ifv_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(Client()), arrayOf([]), false));
          var tmp$ret$29 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$29);
          var tmp$ret$33 = xDataClassPathInsideSet(get__id(it), ids);
          return $this$remember.baj(tmp.feo(new (Query())(tmp$ret$33)));
        });
      }
      ucv() {
        return this.hji_1;
      }
      rhi(_this__u8e3s4) {
        _this__u8e3s4.jbb(sizeConstraints(_this__u8e3s4, VOID, get_AppDimensions().eg2_1), projectList(_this__u8e3s4, ProjectLens_Contractor_getInstance(), this.nji_1, this.oji_1, this.kji_1));
      }
    }
    protoOf($).bhg = get_requiredMembershipRole;
    protoOf($).dhg = get_awaitingApprovalMessage;
    protoOf($).ehg = renderFinishRegistration;
    protoOf($).fhg = renderAwaitingApproval;
    protoOf($).ud6 = render;
    initMetadataForClass($, 'ContractorProjects', ContractorProjects, VOID, [ContractorPage()]);
    ContractorProjectsClass = $;
  }
  return ContractorProjectsClass;
}
//region block: exports
export {
  ContractorProjects as ContractorProjects2hltgp2s6pm9i,
};
//endregion

//# sourceMappingURL=ContractorProjects.mjs.map
